import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueLazyload from 'vue-lazyload'
import VueClipboard from 'vue-clipboard2';
import echarts from 'echarts'  


import Rem from '@/utils/rem.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import { List } from 'vant';  
Vue.use(List);

import 'vant/lib/index.css';
import MySocket from './network/socket';
Vue.use(MySocket)

Rem(1920,1920,1860);
//Rem(1920,1920,1720);


Vue.prototype.$echarts = echarts
Vue.config.productionTip = false
Vue.use(ElementUI);

Vue.use(Vant);


Vue.use(VueClipboard)

Vue.use(VueLazyload,{
  loading:require('@/assets/images/loading-svg/loading-bars.svg'),
  error:require('@/assets/images/none.jpg'),
})

new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    eventHub: new Vue()
    }
}).$mount('#app')
